module.exports = "/_next/static/images/DeletionRequests@2x-ab8f167eb42a1a9ec4d841b9f18cc61c.webp";